import styled from 'styled-components'

export const BasicTextContainer = styled.div`
  align-items: ${props => props.fontAlignement ? props.fontAlignement : "flex-start"};
  justify-content: center;
  flex-direction: column;
  display: flex;
  height: 100%;
  .stylePersonalized > p, h1, h2, h3, h4 {
    background-color: ${props => props.activeBackground && "#ffffff00 !important"};
  }
`

export const Label = styled.div`
  color: ${props => props.labelColor ? props.labelColor : "#000"};
  font-size: ${(props) => props.labelSize ? props.labelSize : "1rem"};
  font-weight: ${(props) => props.labelWeight ? props.labelWeight : "bold"};
`

export const Text = styled.div`
  text-align: ${props => props.basicTextAlignement ? props.basicTextAlignement : "left"};
  color: ${props => props.basicTextColor ? props.basicTextColor : "#000"};
  font-size: ${props => props.basicTextSize ? props.basicTextSize : "1rem"};
  height: 100%;
  width: 100%;
  padding: 10px 10px 10px 0;
  flex:1;
  overflow: auto;
`
